module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9661.96bf19e2.jpg";